import React from "react";
import { Link } from "react-router-dom";

// Color name → hex map for swatches
const COLOR_HEX = {
  Navy: "#0A192F",
  Seafoam: "#2DD4BF",
  White: "#FFFFFF",
  Coral: "#F43F5E",
  "Light Blue": "#A5D8FF",
  "Ice Blue": "#CFE9FF",
  Sand: "#E9E2D3",
  "Light Gray": "#D1D5DB",
  "Slate Blue": "#64748B",
  Slate: "#475569",
  Aqua: "#67E8F9",
  "Heather Navy": "#1E293B",
  "Heather Gray": "#9CA3AF",
};

const swatchStyle = (name) => {
  const hex = COLOR_HEX[name] || "#9CA3AF";
  return {
    backgroundColor: hex,
    border: hex === "#FFFFFF" ? "1px solid rgba(10,25,47,0.2)" : "1px solid rgba(10,25,47,0.1)",
  };
};

export const ProductCard = ({ product, index = 0 }) => {
  const colors = product.colors || [];
  const href = product._initialColor
    ? `/products/${product.slug}?color=${encodeURIComponent(product._initialColor)}`
    : `/products/${product.slug}`;
  return (
    <Link
      to={href}
      data-testid={`product-card-${product.id || product.slug}`}
      className="group flex flex-col"
      style={{ animationDelay: `${index * 60}ms` }}
    >
      <div className="relative overflow-hidden bg-sand aspect-square p-3">
        <img
          src={product.image}
          alt={product.name}
          className="w-full h-full object-contain transition-transform duration-[900ms] ease-out group-hover:scale-[1.04]"
          loading="lazy"
        />
        {product.tag && (
          <span className="absolute top-3 left-3 bg-white text-navy text-[10px] font-bold uppercase tracking-[0.18em] px-2.5 py-1 z-10">
            {product.tag}
          </span>
        )}
      </div>
      <div className="mt-4 flex items-start justify-between gap-2">
        <div className="flex-1 min-w-0">
          <h3 className="font-display text-sm md:text-base font-semibold text-navy leading-tight group-hover:text-seafoam-600 transition-colors">
            {product.name}
          </h3>
          {colors.length > 0 && !product._initialColor && (
            <div className="flex items-center gap-1.5 mt-2" data-testid={`product-swatches-${product.slug}`}>
              {colors.slice(0, 8).map((c) => (
                <span
                  key={c}
                  title={c}
                  style={swatchStyle(c)}
                  className="w-3 h-3 rounded-full inline-block"
                />
              ))}
              {colors.length > 8 && (
                <span className="text-[10px] text-navy/50 ml-0.5">+{colors.length - 8}</span>
              )}
              <span className="text-[11px] text-navy/50 ml-1 uppercase tracking-widest">
                {colors.length} {colors.length === 1 ? "color" : "colors"}
              </span>
            </div>
          )}
        </div>
        <div className="text-sm font-bold text-navy whitespace-nowrap">${product.price.toFixed(2)}</div>
      </div>
    </Link>
  );
};
